// Estado base para limpiar datos sensibles de la sesion.
// No resuelve cache de despliegue; solo evita que queden datos en memoria.
export const initialState = {
  auth: {
    token: null,
    user: {},
    access: []
  },
  client: {
    selected: null
  },
};

export const resetState = (state) => {
  Object.keys(initialState).forEach(key => {
    if (state[key] !== undefined) {
      state[key] = JSON.parse(JSON.stringify(initialState[key]));
    }
  });
};



// WEBPACK FOOTER //
// ./src/store/reset.js